import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Catalog from "@/pages/Catalog";
import ProviderKeys from "@/pages/ProviderKeys";
import Playground from "@/pages/Playground";
import Assistants from "@/pages/Assistants";
import ApiAccess from "@/pages/ApiAccess";
import Usage from "@/pages/Usage";
import Admin from "@/pages/Admin";
import Compare from "@/pages/Compare";
import VerifyEmail from "@/pages/VerifyEmail";

const Loading = () => (
  <div className="flex min-h-screen items-center justify-center text-slate-400" data-testid="auth-loading">Lade…</div>
);

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/app" replace /> : children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><AuthPage initial="register" /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/app" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="providers" element={<ProviderKeys />} />
              <Route path="playground" element={<Playground />} />
              <Route path="compare" element={<Compare />} />
              <Route path="assistants" element={<Assistants />} />
              <Route path="api-access" element={<ApiAccess />} />
              <Route path="usage" element={<Usage />} />
              <Route path="admin" element={<Protected admin><Admin /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
